// extracted by mini-css-extract-plugin
export default {"main":"style_main__TDhMv","logo":"style_logo__ugmIy","declaimer":"style_declaimer__FFiNp","declaimertext":"style_declaimertext__RWP7n","iconDeclaimer":"style_iconDeclaimer__HJV9P"};